import styled from 'styled-components'
import { Instructions } from '../Typography'

const AuthInstructions = styled(Instructions)`
  margin: 1.5625rem 0 1.25rem;
`

export default AuthInstructions
